import React, { Component, Fragment } from 'react'
import { Trans, withTranslation } from 'react-i18next'
import { Field } from 'redux-form/dist/redux-form'
import SelectLanguageField from '../../formFields/SelectLanguageField'
import { TextAreaField } from '../../formFields/TextAreaField'
import TranslationsAcordion from './Professional.Form.Translations.Acordion'
import './Professional.Form.Translations.Acordion.scss'

class ProfessionalTranslationsField extends Component {
  onDeleteClick = (translation, index) => {
    const { fields } = this.props
    if (fields.length === 1) return null
    this.props.fields.remove(index)
  }

  render() {
    const { fields, t } = this.props
    return (
      <>
        <label>
          <Trans>Traducciones</Trans>
        </label>
        <div className="add-translation">
          <button type="button" onClick={() => fields.push({})}>
            <i className="fas fa-plus-circle" />
            <Trans>Añadir traducción</Trans>
          </button>
        </div>
        {fields &&
          fields.map((field, index) => {
            let translation = fields.get(index)

            return (
              <Fragment key={index}>
                <TranslationsAcordion language={translation.language} key={index}>
                  <span className={'fas fa-trash-alt'} onClick={() => this.onDeleteClick(translation, index)} />
                  <Field name={`${field}.language`} component={SelectLanguageField} placeholder={t('Idioma')} />
                  <label>
                    <Trans>Título</Trans>
                  </label>
                  <Field name={`${field}.title`} component={TextAreaField} />
                  <label>
                    <Trans>Título html</Trans>
                  </label>
                  <Field name={`${field}.title_html`} component={TextAreaField} />
                  <label>
                    <Trans>Descripción</Trans>
                  </label>
                  <Field name={`${field}.overview`} component={TextAreaField} />
                </TranslationsAcordion>
              </Fragment>
            )
          })}
      </>
    )
  }
}

export default withTranslation()(ProfessionalTranslationsField)
